<template>
  <span>
    <svg
      width="24"
      height="9"
      viewBox="0 0 24 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1788 7.59795C8.79225 5.93004 6.74455 3.78462 4.5 2.5C2.13956 1.14906 0 0 0 0H24C24 0 21.8604 1.14906 19.5 2.5C17.2554 3.78462 15.2078 5.93004 13.8212 7.59795C12.906 8.69892 11.094 8.69892 10.1788 7.59795Z"
        fill="#4EBC73"
      />
    </svg>
  </span>
</template>
